<template>
    <div>
        <div class="relative">
            <input
                type="email"
                class="input pl-8"
                :class="[isValid ? '' : 'border-red-500']"
                :placeholder="placeholder || __('Endereço de e-mail')"
                :value="value"
                @input="$emit('input', $event.target.value)"
                @blur="$emit('blur')"
            />

            <div
                class="absolute inset-y-0 left-0 flex items-center mx-2"
                :class="[isValid ? 'text-gray-500' : 'text-red-500']"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'

export default {
    props: ['value', 'field'],
    computed: {
        isValid() {
            if (!this.value) return true
            return /^\S+@\S+\.\S+$/.test(this.value)
        },

        placeholder() {
            return Form.placeholder(this.field)
        },
    },
}
</script>
